// extracted by mini-css-extract-plugin
export default {"horizontal_line":"style_horizontal_line__ZmSK+","footer_content":"style_footer_content__MKVX9","footer_text1":"style_footer_text1__cupJo","footer_text2":"style_footer_text2__AGWT7"};